<template>
  <div v-if="status == 0 && isMine">
    <span class="text-lg font-bold" :class="`text-${color}`">未</span>
    <span class="text-sm font-bold" :class="`text-${color}`">作成</span>
  </div>
  <div v-if="status == 0 && !isMine">
    <span class="text-lg font-bold text-white">未</span>
    <span class="text-sm font-bold text-white">作成</span>
  </div>
  <div v-if="status == 1">
    <span class="text-lg font-bold" :class="`text-${color}`">作</span>
    <span class="text-sm font-bold" :class="`text-${color}`">成中</span>
  </div>
  <div v-if="status == 2">
    <span class="text-lg font-bold" :class="`text-${color}`">確</span>
    <span class="text-sm font-bold" :class="`text-${color}`">認待</span>
  </div>
  <div v-if="status == 3">
    <span class="text-lg font-bold" :class="`text-${color}`">再</span>
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
  </div>
  <div v-if="status == 4">
    <span class="text-lg font-bold text-white">確認</span>
    <span class="text-sm font-bold text-white">済</span>
  </div>
  <div v-if="status == 5">
    <span class="text-sm font-bold text-white">確認</span>
    <span class="text-lg font-bold text-white">済</span>
  </div>
  <div v-if="status == 6">
    <span class="text-lg font-bold text-white">確</span>
    <span class="text-sm font-bold text-white">認待</span>
  </div>
  <div v-if="status == 7">
    <span class="text-lg font-bold text-white">再</span>
    <span class="text-sm font-bold text-white">確認</span>
  </div>
  <div v-if="status == 8">
    <span class="text-lg font-bold text-white">未</span>
    <span class="text-sm font-bold text-white">作成</span>
  </div>
</template>
<script>
export default {
  name: 'AppDocumentStatusText_TODA',

  props: {
    status: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '',
    },
    isMine: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
